module.exports = __webpack_public_path__ + "static/media/header-small.28cf972a.jpg";